import React, { FC } from 'react'
import { fetchAllClientData } from 'apis/client'
import { setClientStorage, setConstructorUserAttributes } from 'store/middleware/client'
import { getCartData } from 'components/CartUrgencyBar/helper'
import Register from '../Forms/Register'
import Modal from 'components/SA/Modal/v2'
import { ModalComponentProps } from './Auth'
import styles from './Auth.module.scss'

export const MODAL_NAME = 'register'

const RegisterModal: FC<ModalComponentProps> = (props) => {
  const { closeModal, loginModal, updateSession } = props

  const handleSubmit = async () => {
    // Fetch Session and Cart data
    const { payload: allClientData, success } = await fetchAllClientData()
    if (!success) {
      console.error('Problem Fetching Session')
      return
    }
    setClientStorage(allClientData)
    await getCartData()
    const { cart, cookie, session } = allClientData

    // Constructor configuration
    if (Boolean(session)) {
      setConstructorUserAttributes({
        isMobileTraffic: allClientData.isMobileTraffic,
        isAuthenticated: session.isAuthenticated,
        userId: session.userId,
        userCountryCode: session.userCountryCode,
        userRole: session.userRole,
        userRegionCode: allClientData?.locale?.regionCode,
      })
    }

    updateSession({ cart: cart.count || 0, cookie, session })
    closeModal()
  }

  return (
    <Modal
      name={MODAL_NAME}
      onCloseModal={closeModal}
      layout='standard'
      styleOverride={styles.authModal}
      fullTakeover={true}
      isCloseButtonVisible
    >
      <>
        <Register onClickLogIn={loginModal} onSubmit={handleSubmit} />
      </>
    </Modal>
  )
}

export default RegisterModal
